module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"measure_widget_label":"Maßnahmen","measure_widget_mymeasures":"Meine Aufgaben","measure_widget_allmeasures":"Relevante Aufgaben","measure_widget_due_date":"Zu erledigen bis: "},"en":{"measure_widget_label":"My Measures","measure_widget_due_date":"Due date: "}}')
  delete Component.options._Ctor
}
